import $ from 'jquery';
import { fabric } from 'fabric';
import { showSidebarTab } from '~src/sidebarLegacy';
import { hideAllMenus } from '~core/hideAllMenus';
import { getState, modifyState } from '~src/state';
import {
  showCursor,
  handleCloneStampApply,
  updateCloneStampBrush,
} from '~core';

export const startCloneStamp = (
  mode = window.CloneStamp.MODE_PROGRESSIVE
) => () => {
  // TODO: reset state between clone stamp / sfuma
  // window.drawingCanvas.clear();
  // window.drawingCanvas.requestRenderAll();

  // TODO: when starting the eraser after clone stamp, reset the cursor
  // TODO: when clone stamp after eraser, the eraser is lost

  showCursor();

  if (mode === window.CloneStamp.MODE_PROGRESSIVE) {
    $('#editor-image-clone-stamp-title').text('TIMBRO CLONE');
    $('#editor-image-clone-stamp-progressive-container').show();
    $('#editor-image-clone-stamp-alpha-container').show();
    $('#editor-image-clone-stamp-brush-preview-container').show();
    $('[data-clone-stamp]').show();
    $('#sample').show();
  } else {
    $('[data-clone-stamp]').hide();
    $('#editor-image-clone-stamp-title').text('SFUMA');
    $('#editor-image-clone-stamp-progressive-container').hide();
    $('#editor-image-clone-stamp-alpha-container').hide();
    $('#editor-image-clone-stamp-brush-preview-container').hide();
    $('#sample').hide();
  }

  modifyState('isCloneStampActive', true);
  showSidebarTab('image-clone-stamp');
  hideAllMenus();
  $('#main-canvas-container').fadeOut(() => {
    $('#clone-stamp-container').show();
    $('#drawing-canvas').fadeIn();
  });

  window.brushCanvas = document.querySelector('#brush-canvas');

  if (mode === window.CloneStamp.MODE_PROGRESSIVE) {
    const cursorCanvas = getState('cursorCanvas');

    window.drawingCanvas.on('mouse:move', function (evt) {
      const mouse = this.getPointer(evt.e);
      const mouseCursor = getState('mouseCursorStampClone');
      if (!mouseCursor) {
        return;
      }
      mouseCursor.set({
        // scaleX: 2,
        // scaleY: 2,
        top: mouse.y + window.brushCanvas.height / 2,
        left: mouse.x + window.brushCanvas.width / 2,
      });
      // .setCoords();

      window.cursorCanvas.renderAll();
    });

    const mouseCursor = new fabric.Circle({
      left: 0,
      top: 0,
      radius: 30,
      fill: 'transparent',
      stroke: 'black',
      originX: 'center',
      originY: 'center',
      scaleX: 1,
      scaleY: 1,
      visible: true,
    });

    cursorCanvas.clear();
    cursorCanvas.add(mouseCursor);
    cursorCanvas.requestRenderAll();
    modifyState('mouseCursorStampClone', mouseCursor);

    window.addEventListener('contextmenu', (e) => {
      const isCloneStampActive = getState('isCloneStampActive');
      if (!isCloneStampActive || !window.CloneStamp.drawingEnabled) {
        return;
      }

      window.CloneStamp.setSampleAtMousePosition(e);

      new fabric.Image.fromURL(
        window.brushCanvas.toDataURL('image/png'),
        (img) => {
          cursorCanvas.clear();
          img.set({ visible: true });
          cursorCanvas.add(img);
          cursorCanvas.requestRenderAll();
          const mouseCursor = cursorCanvas.getObjects()[0];
          modifyState('mouseCursorStampClone', mouseCursor);
        }
      );
    });
  }

  window.CloneStamp.setMode(mode);
  window.CloneStamp.enableDrawing();

  window.CloneStamp.init(window.canvas.getActiveObject(), {
    drawingCanvasSelector: '#drawing-canvas',
    brushCanvasSelector: '#brush-canvas',
    manipulationCanvasSelector: '#manipulation-canvas',
    applyBtnSelector: '#editor-menu-apply-clone-stamp',
    undoBtnSelector: '#editor-menu-undo-clone-stamp',
    redoBtnSelector: '#editor-menu-redo-clone-stamp',
    shouldClipWithinOriginalImageBounds: true,
    onApply: handleCloneStampApply,
    onReady: () => {
      updateCloneStampBrush();
    },
  });
};
